import React, {useEffect, useState, useContext, useRef} from 'react';
import {
  Column,
  Grid,
  Header,
  HeaderContainer,
  HeaderName,
  HeaderNavigation,
  HeaderMenuButton,
  HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  Modal,
  SkipToContent,
  SideNav,
  SideNavItems,
  HeaderSideNavItems,
  HeaderPanel,
  SwitcherItem,
  SwitcherDivider,  
  HeaderMenu
} from 'carbon-components-react';
import {Switcher, UserAvatar} from '@carbon/react/icons';
import {Link} from 'react-router-dom';
import {ThemeContext} from '../../context/ThemeProvider';
import {getLogonData, getCountriesList,getDelegationList} from '../../services/services';
import MessageModal from '../../components/MessageModal/MessageModal';
import SessionController from '../../components/FrontSessionController/SessionController';
import ModalRequestEmployee from '../../content/ModalRequestEmployee/ModalRequestEmployee';

const CommodityHeader = () =>  {  
  const [menu, setMenu] = useState([]);
  const [commonEmployeeMenu, setCommonEmployeeMenu] = useState([]);
  const [userAvatar, setUserAvatar] = useState(false);
  const [userPanel, setUserPanel] = useState(false);
  const [switcherIcon, setSwitcherIcon] = useState(false);
  const [switcherPanel, setSwitcherPanel] = useState(false);
  const {theme, setEmail, setProfile, setRol, setUserType, setCountriesList
    ,setLaVatSplitEnable
    ,setEmeaVatSplitEnable
    ,setTestEnviroment} = useContext(ThemeContext);
    
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [modalRequestEmployee,setModalRequestEmployee] = useState(false);
  const [modalShowDelegations,setModalShowDelegations] = useState(false);
  const [userDelegations,setUserDelegations] = useState([]);
  
  const [appUrlKiosk,setAppUrlKiosk] = useState('');
  const [appUrlIss,setAppUrlIss] = useState('');
  const [appUrlCommManager,setAppUrlCommManager] = useState('');


  //for modal error or information use
  const [messageModal, setMessageModal] = useState('');
  const messageResponse = useRef([]);  
  //for showing message and making cursong round for request
  const processingRequest = useRef(false);
    
  const profileName = theme.profile;
  const userType = theme.userType;

  const listRolCommonEmployeeMenu = [
    {
      "id": 6,
      "name": "List Delegations",
      "options": [
         {
            "id": 61,
            "name": "List Delegations",
            "path": "private-delegations",
            "rol": "Approver"
         }]
    },
    {
       "id": 5,
       "name": "Request Access for an Employee",
       "options": [
          {
             "id": 51,
             "name": "Request Access for an Employee",
             "path": "request-access",
             "rol": "Approver"
          }]
    },
  ]

  const listRolMenu = [    
    {
       "id": 1,
       "name": "Assignments/Actions",
       "options": [

          {
             "id": 13,
             "name": "Unique Expenditure",
             "path": "unique-expenditure",
             "rol": "Approver"
          },

          {
             "id": 15,
             "name": "Id's With Error",
             "path": "ids-with-error",
             "rol": "Approver"
          },
          {
             "id": 16,
             "name": "Approver Delegation",
             "path": "approvers-delegation",
             "rol": "Approver"
          },
          {
             "id": 17,
             "name": "Documents Deletion",
             "path": "documents-deletion",
             "rol": "Approver"
          },

          {
             "id": 19,
             "name": "Attachment Admin",
             "path": "attachments-admin",
             "rol": "Approver"
          },
       ]
    },
    {
       "id": 2,
       "name": "Logs",
       "options": [
          {
             "id": 21,
             "name": "Operation Log",
             "path": "operations-log",
             "rol": "Approver"
          },
          {
             "id": 22,
             "name": "Follow Up Log",
             "path": "follow-up-log",
             "rol": "Approver"
          },
          {
             "id": 20,
             "name": "Validation Log",
             "path": "validation-log",
             "rol": "Approver"
          },
          {
             "id": 26,
             "name": "RTV Log",
             "path": "rtv-log",
             "rol": "Approver"
          },
       ]
    },
    {
       "id": 3,
       "name": "Views",
       "options": [
          {
             "id": 34,
             "name": "Approver's List",
             "path": "view-approvers-list",
             "rol": "Approver"
          },
          {
             "id": 38,
             "name": "View Managers",
             "path": "view-managers",
             "rol": "Approver"
          },
          {
             "id": 33,
             "name": "View Departments",
             "path": "view-departments",
             "rol": "Approver"
          },
          {
             "id": 32,
             "name": "View Projects",
             "path": "view-projects",
             "rol": "Approver"
          },
          {
             "id": 35,
             "name": "View Commodities",
             "path": "view-commodities",
             "rol": "Approver"
          },
          {
             "id": 37,
             "name": "Tax Condition",
             "path": "tax-condition",
             "rol": "Approver"
          }]
    }
 ];

 //start controller error modal
 const openMessageModal = (response) => {    
  let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
  messageResponse.current = newMessageResponse;
  setMessageModal(true);
}

const closeMessageModal = () => {
  setMessageModal(false);    
  messageResponse.current = [];
}

const isRequestActive = (enable) => {
  if(enable){
    if(processingRequest.current){
      openMessageModal('The request is processing');
      return true;
    }
    document.body.className = 'waiting';
    processingRequest.current = enable;      
    return false;
  }else{
    processingRequest.current = enable;
    document.body.className = '';
  }
  return false;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    // Collect all arguments passed to the debounced function
    clearTimeout(timeout); // Clear any existing timeout
    timeout = setTimeout(() => {
      func.apply(this, args); // Execute the original function with the correct context and arguments
    }, delay);
  };
}

  const openUserMenu = () => {
    setUserAvatar(!userAvatar);
    setUserPanel(!userPanel);
    if(switcherPanel === true) setSwitcherPanel(false);
    if(switcherIcon === true) setSwitcherIcon(false); 
  };

  const openSwitcherMenu = () => {
    setSwitcherIcon(!switcherIcon);
    setSwitcherPanel(!switcherPanel);
    if(userAvatar === true) setUserAvatar(false);
    if(userPanel === true) setUserPanel(false);
  };

  const requestUserDataIsActive = useRef(false);
  const getUserData = () => {
    if(requestUserDataIsActive.current) {return}
    requestUserDataIsActive.current = true;
    getLogonData()
      .then(response => {
        if (response.status === 200) {        
          response.json()
            .then(response => {
              setProfile(response.rol);
              setEmail(response.email);
              setRol(response.rol);
              setUserType(response.userType);
              setLaVatSplitEnable(response.laVatSplitEnable);
              setEmeaVatSplitEnable(response.emeaVatSplitEnable);
              setTestEnviroment(response.testEnviroment);
              setAppUrlKiosk(response.appUrlKiosk);
              setAppUrlIss(response.appUrlIss);
              setAppUrlCommManager(response.appUrlCommManager);
            })      
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }
      requestUserDataIsActive.current = false;
    });         
  };

  const openModalRequestEmployee = () => {
    setModalRequestEmployee(true);
  }  

  const closeModalRequestEmployee = () => {    
    setModalRequestEmployee(false);
  }

  const openModalShowDelegations = () => {
    getDelegationList()
    .then(response => {
      if (response.status === 200) {
        response.json()
          .then(response => {
            console.log(response);
            setUserDelegations(response);
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
        })
      }   
    })
    setModalShowDelegations(true);
  }

  const requestCountryListIsActive = useRef(false);
  const getCountries = () => {
    if(requestCountryListIsActive.current){return}    
    requestCountryListIsActive.current = true;
    getCountriesList()
    .then(response => {
      if (response.status === 200) {
        response.json()
          .then(response => {
            setCountriesList(response);
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
        })
      }   
      requestCountryListIsActive.current = false;
    })
  }

  const closeModalShowDelegations = () => {
    setModalShowDelegations(false);
  }

 

  useEffect(() => {
    setCommonEmployeeMenu(listRolCommonEmployeeMenu);
    setMenu(listRolMenu);
    getUserData();    
    getCountries();
  }, []); 


  return (<>
  
   <HeaderContainer
    render={({ isSideNavExpanded, onClickSideNavExpand }) => (
      <Header aria-label="Carbon Tutorial" theme="g90">
        <SkipToContent />
        <HeaderMenuButton
          aria-label="Open menu"
          onClick={onClickSideNavExpand}
          isActive={isSideNavExpanded}
        />
        <HeaderName prefix="IBM" element={Link} to="/" theme="g90">
          Invoice Approval System
        </HeaderName>
        <HeaderNavigation aria-label="Carbon Tutorial" theme="g90">

          
        <>
          {commonEmployeeMenu.map(menuName => (
            <>                
                {(menuName.options.length === 1 && menuName.id === 5) && 
                  <HeaderMenuItem element={Link} onClick={openModalRequestEmployee}>
                    {menuName.name}
                  </HeaderMenuItem>}
                {(menuName.options.length === 1 && menuName.id === 6) && 
                  <HeaderMenuItem element={Link} onClick={openModalShowDelegations}>
                    {menuName.name}
                  </HeaderMenuItem>}
            </>
          ))
          }
        </>
          
          
        {userType == 'privilegedUser' &&
          <>
          {menu.map(menuName => (
            <>
              {menuName.options.length > 1 && 
                <HeaderMenu aria-label={menuName.name} menuLinkName={menuName.name}>
                  <>
                    {menuName.options.map(option => (                    
                      <>
                        <HeaderMenuItem element={Link} to={"/" + option.path}>
                          {option.name}
                        </HeaderMenuItem>
                      </>
                    ))}
                  </>
                </HeaderMenu>}              
            </>
          ))
          }
          </>                
        }
        </HeaderNavigation>
        <SideNav
          aria-label="Side navigation"
          expanded={isSideNavExpanded}
          isPersistent={false}
        >
          <SideNavItems>
            <HeaderSideNavItems>            
            {menu.map(menuItem => (
            <>
            {<HeaderMenuItem element={Link} to={menuItem.path}>
              {menuItem.name}
            </HeaderMenuItem>
            }
            </>            
          ))}
            </HeaderSideNavItems>
          </SideNavItems>
        </SideNav>
        <HeaderGlobalBar>
          
          <HeaderGlobalAction aria-label="Profile" tooltipAlignment="center" isActive={userAvatar} onClick={openUserMenu}>
            <UserAvatar size={20} />
          </HeaderGlobalAction>
          <HeaderGlobalAction aria-label="Menu" tooltipAlignment="end" isActive={switcherIcon} onClick={openSwitcherMenu}>
            <Switcher size={20} />
          </HeaderGlobalAction>
        </HeaderGlobalBar>
        {userPanel && <HeaderPanel aria-label="Header Panel" className="header-panel user-menu-list" style={{height:"9rem", width:"20rem", "list-style-type": "none"}}> 
            <SwitcherItem className="user-menu-list" aria-label="User">
              User: {theme.email}
            </SwitcherItem>
            <SwitcherItem className="user-menu-list" aria-label="Rol">
              Profile: {theme.profile}
            </SwitcherItem>
            <SwitcherDivider />
            <SwitcherItem href={appUrlKiosk} aria-label="Exit">
              Exit
            </SwitcherItem>        
        </HeaderPanel>}
        {switcherPanel && <HeaderPanel aria-label="Header Panel" className="header-panel user-menu-list" style={{height:"14rem", width:"15rem", "list-style-type": "none"}}> 
            <SwitcherItem className="user-menu-list" aria-label="Invoice Reception" href={appUrlKiosk}>
              Invoice Reception
            </SwitcherItem>
            <SwitcherItem className="user-menu-list" aria-label="Commodity Approval" href={appUrlCommManager}>
              Commodity Approval
            </SwitcherItem>
            <SwitcherItem className="user-menu-list" aria-label="Link 2" href={appUrlIss}>
              Status Module
            </SwitcherItem>                    
        </HeaderPanel>}

        
      </Header>
      
    )}
    
  />
  
        <Modal        
        className="onboarding-modal"
        modalHeading='Delegations'
        modalLabel="Invoice Approval System"
        hasscrollingcontent="false"
        onRequestClose={closeModalShowDelegations}
        onRequestSubmit={() => closeModalShowDelegations()}        
        open={modalShowDelegations}
        primaryButtonText="Ok"
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        size={'lg'}
        >                  
          <Grid >
            <Column lg={16}>
              
              {(userDelegations.lDelegations!==undefined && userDelegations.lDelegations.length > 0) ?(
                userDelegations.lDelegations.map(delegation => (
                  <>
                    <p>{delegation.fromUser} -> Delegated To {delegation.toUser} for Country {delegation.country} since {delegation.fechaDesde} Until {delegation.fechaHasta}</p>
                  </>
                ))
              ):(
                <p>Empty</p>
              )
              }
            </Column>
          </Grid>
        </Modal>
        
    <ModalRequestEmployee modalRequestEmployeeCallback={modalRequestEmployee} closeModalRequestEmployeeCallback={closeModalRequestEmployee}/>
    <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
    <SessionController messageLostSessionCallback={messageSessionLost} />
    </>
)}
;

export default CommodityHeader;